module.exports = __webpack_public_path__ + "static/carGold2-ebdcf7e8f9c974547da122959b74ca2e.png";